import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { mainReportPayload } from "../../models/Myprojects";

interface State {
  isReports: boolean;
  isProjectDetails: boolean;
  loading: boolean;
  error: string | undefined;
}

export const initialState: State = {
  isReports: false,
  isProjectDetails: false,
  loading: false,
  error: '',
};

const ReportSlice = createSlice({
  name: 'Reports',
  initialState,
  reducers: {
    setIsReports(state, action: PayloadAction<boolean>) {
      state.isReports = action.payload;
    },
    setIsProjectDetails(state, action: PayloadAction<boolean>) {
      state.isProjectDetails = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase('DOWNLOAD_MAIN_REPORT_SUCCESS', (state) => {
        state.loading = false;
        state.error = '';
      })
      .addCase('DOWNLOAD_MAIN_REPORT_FAILURE', (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message || 'Download failed';
      });
  },
});

// Action creators
export const downloadMainReport = (payload: mainReportPayload) => ({
  type: 'DOWNLOAD_MAIN_REPORT',
  payload,
});

export const downloadMainReportSuccess = (data: any) => ({
  type: 'DOWNLOAD_MAIN_REPORT_SUCCESS',
  payload: data,
});

export const downloadMainReportFailure = (error: any) => ({
  type: 'DOWNLOAD_MAIN_REPORT_FAILURE',
  error,
});

export const { setIsReports, setIsProjectDetails, setLoading, setError } = ReportSlice.actions;

export default ReportSlice.reducer;
